@if (!routerLink()) {
  <span
    class="resize-td"
    [class]="class()"
    [innerHTML]="value() | highlight: highlight() || ''"
  ></span>
}
@if (routerLink()) {
  <a
    class="resize-td"
    [routerLink]="routerLink()"
    [queryParams]="queryParams()"
    [class]="class()"
    [innerHTML]="value() | highlight: highlight() || ''"
  ></a>
}
